import { StandardLayout } from "../../layouts/StandardLayout"

export default function PageDoesNotExist(){
    return(
        <StandardLayout title={"uh oh!"} content={"this page does not exist."} />
    )
}